import React, { useState, useEffect } from 'react';
import MobileFooter from './MobileFooter';
import DesktopFooter from './DesktopFooter';

const FooterConfig = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 500);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 500);
    };

    window.addEventListener('resize', handleResize);
    
    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobile ? <MobileFooter /> : <DesktopFooter />;
};

export default FooterConfig;